import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { SppdashboardService } from '../dashboard/sppdashboard.service';
import { EmailUpdateService } from './email-update.service';
import { Router } from '@angular/router';
import { HelpdeskService } from '../admin/helpdesk/helpdesk.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-email-update-form',
  templateUrl: './email-update-form.component.html',
  styleUrl: './email-update-form.component.scss',
  standalone: false
})
export class EmailUpdateFormComponent implements OnInit {
  public emailForm: any;
  public isProfileForm: boolean = true;
  public userId: any;
  public userMessage: any;
  public email: any = '';
  public subject: any;
  public snackbar = inject(MatSnackBar);
  isFormSubmitted: boolean = false;

  constructor(
    private sppdashboardService: SppdashboardService,
    private _email: EmailUpdateService,
    private _fb: FormBuilder,
    private router: Router,
    private helpService: HelpdeskService
  ) { }

  // Custom email validator
  customEmailValidator(control: AbstractControl): ValidationErrors | null {
    const email = control.value;
    if (!email) {
      return null; // Don't validate empty values, let required validator handle that
    }

    // More strict email regex pattern
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailPattern.test(email)) {
      return { invalidEmail: true };
    }

    return null;
  }

  ngOnInit() {

    this.emailForm = this._fb.group({
      email: [{ value: '', disabled: true }],
      newEmail: ['', [Validators.required, this.customEmailValidator]],
      user_remarks: ['', Validators.required],
    });

    this.email = sessionStorage.getItem('email')

    // get  the user details to populate the form
    this.sppdashboardService.getUser().subscribe((response: any) => {
      if (response.success === true) {
        this.userId = response.data.userid;
        this.emailForm.patchValue({
          email: response.data.email,
        });

        this.gettheUpdatedStatus();
        // this._email.getProfileUpdateStatus(this.userId).subscribe((res: any) => {
        //   if (res) {
        //     let status = res.data[0].status;
        //     if (status == 'SUBMIT') {
        //       this.isProfileForm = false;
        //       this.userMessage = "Your Request for Profile Merge has been Submitted, wait until Admin approves it";
        //     } else {
        //       this.isProfileForm = true;
        //     }
        //   }
        // });
      }
    });
  }


  gettheUpdatedStatus() {
    // GET THE USER PROFILE UPDATE STATUS BY USING USER ID
    this._email.getProfileUpdateStatus(this.userId).subscribe((res: any) => {
      if (res) {
        let status = res.data[0].status;
        if (status == 'SUBMIT') {
          this.isProfileForm = false;
          this.userMessage = `Thank you for submitting your request to change your MCT account email.
          <br/>Your application is under review, and additional information regarding next steps will be provided via email within 3-5 business days.<br/>
          For questions, please contact us at <a aria-label="Email MCT Support at mctpvsupport@pearson.com" href="mailto:mctpvsupport@pearson.com">mctpvsupport@pearson.com</a> - we’re here to help!`;
        } else {
          this.isProfileForm = true;
        }
      }
    });
  }

  onSave() {
    if (this.emailForm.valid) {
      this.isFormSubmitted = true;
      this._email.updateEmail(this.emailForm.getRawValue()).subscribe((res: any) => {
        if (res.success === true) {
          this.emailForm.reset();
          this.gettheUpdatedStatus();
          this.subject = 'Profile merge request submission';
          this.isFormSubmitted = false;

          if (this.email != undefined && this.subject != undefined) {

            const tempObject = {
              "recipientEmail": this.email,
              "subject": this.subject,
              "templateName": 'MCTProfileMergeSubmission',
              "language": "en",
              "customContext": "{}"
            }

            this.helpService.sendEmailUser(tempObject).subscribe((res: any) => {
              if (res.success === true) {

              } else {
                this.snackbar.open(res.errors, '', { verticalPosition: 'top', horizontalPosition: 'center' });
              }
            }, (error: any) => {
              this.isFormSubmitted = false;
              const errMsg = error?.error?.errors ? error?.error?.errors : [error?.error?.error];
              errMsg && errMsg.map((msg: string) => {
                this.snackbar.open(msg, '', { verticalPosition: 'top', horizontalPosition: 'right', panelClass: ['warning'] });
              });
            })
          }
        } else {
          // alert('Failed to submit email update request. Please try again.');
          this.isFormSubmitted = false;
        }
      }, (error) => {
        this.isFormSubmitted = false;
        //alert('An error occurred while submitting the request. Please try again later.');
      });
    } else {
      // Mark all fields as touched to show validation errors
      this.emailForm.markAllAsTouched();
    }


  }

  onBackClick() {
    this.router.navigate(['/mycompany']);
  }

}
